<template>
  <div>
    <skeleton-box v-if="isLoading" width="100px" height="25px" />
    <div v-else class="counter">
      <div class="iCountUp">
        <ICountUp
          class="counter-number"
          :delay="delay"
          :endVal="totalCount"
          :options="options"
        />
      </div>
      <p
        :class="{ 'counter-text__highlight': suffixHighlight }"
        class="counter-text"
      >
        reported incidents
      </p>
    </div>
  </div>
</template>

<script>
import SkeletonBox from "./SkeletonBox.vue";
import ICountUp from "vue-countup-v2";
export default {
  name: "Counter",
  components: { SkeletonBox, ICountUp },
  data() {
    return {
      delay: 1000,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ",",
        decimal: ".",
        prefix: "",
      },
    };
  },
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
    totalCount: {
      type: Number,
    },
    suffixHighlight: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="css">
.counter {
  display: flex;
  width: 130px;
  justify-content: space-between;
  height: 55px;
  align-items: center;
  /* align-self: center; */
  font-weight: bold;
}
.counter-number {
  color: #ec1d23;
  font-size: 20px;
  font-weight: bold;
}
.counter-text {
  display: flex;
  text-align: center;
  color: #000000;
  font-weight: 700;
}
.counter-text__highlight {
  color: white;
}
</style>
